import React from "react";

type PageSectionHeaderProps = {
  eyebrow?: string;
  title: React.ReactNode;
  lead?: React.ReactNode;
  align?: "center" | "start";
  tone?: "default" | "dark";
  headingLevel?: "h1" | "h2";
  id?: string;
  className?: string;
  size?: "default" | "compact";
};

export const PageSectionHeader: React.FC<PageSectionHeaderProps> = ({
  eyebrow,
  title,
  lead,
  align = "start",
  tone = "default",
  headingLevel = "h2",
  id,
  className = "",
  size = "default",
}) => {
  const Heading = headingLevel;
  const classes = [
    "page-section-header",
    `page-section-header--${align}`,
    size === "compact" ? "page-section-header--compact" : "",
    tone === "dark" ? "page-section-header--dark" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <header className={classes}>
      {eyebrow && <p className="page-section-header__eyebrow">{eyebrow}</p>}
      <Heading id={id} className="page-section-header__title">
        {title}
      </Heading>
      {lead && <div className="page-section-header__lead">{lead}</div>}
    </header>
  );
};
